import React from 'react';

/**
 * Main area component for signage layout
 * @param {Object} props - Component props
 * @param {Array} props.mainComponents - Main area components
 * @param {Object} props.gridConfig - Grid configuration
 * @param {Function} props.renderGridComponent - Function to render grid components
 * @param {string} props.imageUrl - Image URL
 * @param {Array} props.markers - Markers data
 * @param {Object} props.planData - Plan data
 * @param {Object} props.legacySignage - Legacy signage data
 * @param {Array} props.categoriesData - Categories data for Space Category component
 * @param {string} props.shortName - Short name for dates array
 * @param {Object} props.renderCountRef - Render count reference
 * @returns {JSX.Element} Main area component
 */
const MainArea = ({ 
  mainComponents, 
  gridConfig, 
  renderGridComponent, 
  imageUrl, 
  markers, 
  planData, 
  legacySignage,
  categoriesData,
  shortName,
  renderCountRef 
}) => (
  <div 
    className="signage-main-grid-container"
    style={{ 
      width: `${gridConfig.dividerRatio * 100}%`, 
      height: "100%",
      background: "linear-gradient(rgba(250, 0, 135, 0.14) 0%, rgba(140, 0, 250, 0.04) 37.5%, rgba(249, 227, 32, 0.04) 64.58%, rgba(214, 238, 255, 0.14) 100%)"
    }}
  >
    {mainComponents.map((transformedComponent) => {
      renderCountRef.current.mainComponents += 1;
      return renderGridComponent(transformedComponent, imageUrl, markers, planData, true, legacySignage, categoriesData, shortName);
    })}
  </div>
);

export default MainArea;
